import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { TaskBoardGroupByEnum } from '@ztechapps/task.common'
import { useTaskFilterBarContext } from '../TaskFilterBar/Context'

type GroupByOption = {
  value: TaskBoardGroupByEnum
  label: string
}

const GROUP_BY_OPTIONS: GroupByOption[] = [
  { value: TaskBoardGroupByEnum.None, label: 'None' },
  { value: TaskBoardGroupByEnum.Project, label: 'Project' },
  { value: TaskBoardGroupByEnum.Assignee, label: 'Assignee' },
  { value: TaskBoardGroupByEnum.WorkOrder, label: 'Production' },
]

export const GroupByDropdown = () => {
  const { groupBy, setGroupBy } = useTaskFilterBarContext()
  const selectedLabel = GROUP_BY_OPTIONS.find((opt) => opt.value === groupBy)?.label ?? 'None'

  return (
    <HorizontalStack gap={2}>
      <span className="small fw-medium text-secondary text-nowrap">
        <Icon name="layer-group" className="me-1" />
        Group by:
      </span>
      <Dropdown>
        <Dropdown.Toggle variant="outline-primary" size="sm" id="task-board-group-by">
          {selectedLabel}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {GROUP_BY_OPTIONS.map((option) => (
            <Dropdown.Item
              key={option.value}
              active={groupBy === option.value}
              onClick={() => setGroupBy(option.value)}
            >
              {option.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </HorizontalStack>
  )
}
